import { adminApiClient } from '../lib/apiClient';

const PRODUCT_IMAGE_BASE_URL =
  process.env.REACT_APP_PRODUCT_IMAGE_BASE_URL ||
  'http://localhost/papad/public/uploads/products/';

function appendIfPresent(formData, key, value) {
  if (value !== undefined && value !== null && String(value).trim() !== '') {
    formData.append(key, String(value).trim());
  }
}

function extractProducts(payload) {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  if (Array.isArray(payload?.data?.data)) {
    return payload.data.data;
  }

  if (Array.isArray(payload?.data?.products)) {
    return payload.data.products;
  }

  if (Array.isArray(payload?.products)) {
    return payload.products;
  }

  return [];
}

export async function listAdminProducts() {
  const formData = new FormData();
  const response = await adminApiClient.post('/admin/products/list', formData);

  return {
    raw: response.data,
    items: extractProducts(response.data),
  };
}

export async function createAdminProduct(payload) {
  const formData = new FormData();

  appendIfPresent(formData, 'category_id', payload.category_id);
  appendIfPresent(formData, 'name', payload.name);
  appendIfPresent(formData, 'description', payload.description);
  appendIfPresent(formData, 'price', payload.price);
  appendIfPresent(formData, 'mrp', payload.mrp);
  appendIfPresent(formData, 'weight', payload.weight);
  appendIfPresent(formData, 'stock', payload.stock);
  appendIfPresent(formData, 'is_best_selling', payload.is_best_selling);

  if (payload.image instanceof File) {
    formData.append('image', payload.image);
  }

  const response = await adminApiClient.post('/admin/products/create', formData);
  return response.data;
}

export async function updateAdminProduct(payload) {
  const formData = new FormData();

  appendIfPresent(formData, 'product_id', payload.product_id);
  appendIfPresent(formData, 'category_id', payload.category_id);
  appendIfPresent(formData, 'name', payload.name);
  appendIfPresent(formData, 'description', payload.description);
  appendIfPresent(formData, 'price', payload.price);
  appendIfPresent(formData, 'mrp', payload.mrp);
  appendIfPresent(formData, 'weight', payload.weight);
  appendIfPresent(formData, 'stock', payload.stock);
  appendIfPresent(formData, 'is_best_selling', payload.is_best_selling);
  appendIfPresent(formData, 'status', payload.status);

  if (payload.image instanceof File) {
    formData.append('image', payload.image);
  }

  const response = await adminApiClient.post('/admin/products/update', formData);
  return response.data;
}

export async function deleteAdminProduct(productId) {
  const formData = new FormData();
  appendIfPresent(formData, 'product_id', productId);

  const response = await adminApiClient.post('/admin/products/delete', formData);
  return response.data;
}

export function buildProductImageUrl(imageName) {
  if (!imageName) {
    return '';
  }

  if (/^https?:\/\//i.test(imageName)) {
    return imageName;
  }

  return `${PRODUCT_IMAGE_BASE_URL}${imageName}`;
}
